/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuCaratWeight_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterCaratWeight_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenuFilterCaratWeight_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuCaratWeight_searchBrowse$ref,
  +$refType: SbRespRefineMenuFilterCaratWeight_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterCaratWeight_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6d08efc690d59f6c7c0c52f28683c654';
module.exports = node;
